import { useTranslation } from 'react-i18next';
import styles from './delete-submodule-dialog.module.scss';
import { Dialog, DialogActions, DialogContent, DialogTitle, GrayOutlinedButton, SecondaryButton, Typography } from '@frontend-workspace/react-shared-lib';

/* eslint-disable-next-line */
export interface DeleteSubmoduleDialogProps {
  open: boolean,
  onClose: () => void,
  deleteSubmodule?: any
}

export function DeleteSubmoduleDialog(props: DeleteSubmoduleDialogProps) {
  const { t } = useTranslation();

  return (
    <Dialog
      open={props.open}
      onClose={() => props.onClose()}
      maxWidth='sm'>
      <DialogTitle className='mb-3'>
        {t("standard.areYouSureYouWantToDelete")}
        {/* {JSON.stringify(deleteProduct?.groupName)} */}
      </DialogTitle>
      <DialogContent>
        <Typography
          component="div"
          variant='subtitle3'>
          {/* Undermodul: {deleteProduct?.productName} */}
        </Typography>
      </DialogContent>
      <DialogActions>
        <SecondaryButton
          variant="contained"
          size='large'
          // onClick={}
          className='minButtonWidth'>
          {t("standard.deleteProduct")}
        </SecondaryButton>
        <GrayOutlinedButton
          variant="outlined"
          size='large'
          onClick={props.onClose}
          className='minButtonWidth'>
          {t("standard.cancel")}
        </GrayOutlinedButton>
      </DialogActions>
    </Dialog>
  );
}

export default DeleteSubmoduleDialog;